import {loadable} from 'router/routes';

const ParkingPass = loadable(() => import('./ParkingPass'));

export default ParkingPass;
